module.exports = __webpack_public_path__ + "static/media/warning.114a920f.svg";